import CheckPermission from '../../../hooks/CheckPermission';
import React, { useState } from 'react'
import toast from 'react-hot-toast'
import {
  FaPlus,
  FaTrash,
  FaPrint,
  FaBroom,
  FaEnvelope,
  FaCalendarAlt,
  FaNotesMedical,
  FaCheck,
  FaDollarSign,
  FaShieldAlt,
  FaMoneyBill
} from 'react-icons/fa'
import CustomButton from '../../../shared/CustomButton'

const BillsTab = ({ patient }) => {
  const { hasPermission } = CheckPermission();
  const [bills, setBills] = useState([
    {
      id: 1,
      date: '2024-06-28',
      timestamp: '2024-06-28 10:30 AM',
      items: [
        { id: 1, name: 'Consultation Fee', quantity: 1, pricePerItem: 150 },
        { id: 2, name: 'Blood Test', quantity: 1, pricePerItem: 75 }
      ],
      note: 'Regular checkup',
      isCheckedOut: true,
      paymentMethod: 'card',
      discountType: 'SAR.',
      discountValue: 10,
      insuranceProvider: 5
    },
    {
      id: 2,
      date: '2024-06-29',
      timestamp: '2024-06-29 11:00 AM',
      items: [
        { id: 1, name: 'X-Ray', quantity: 1, pricePerItem: 200 },
        { id: 2, name: 'MRI Scan', quantity: 1, pricePerItem: 1200 }
      ],
      note: 'Follow-up visit',
      isCheckedOut: false,
      paymentMethod: 'cash',
      discountType: 'Percentage',
      discountValue: 5,
      insuranceProvider: 10
    },
    {
      id: 3,
      date: '2024-06-30',
      timestamp: '2024-06-30 09:00 AM',
      items: [
        { id: 1, name: 'Blood Pressure Check', quantity: 1, pricePerItem: 50 },
        { id: 2, name: 'ECG', quantity: 1, pricePerItem: 300 }
      ],
      note: 'Emergency visit',
      isCheckedOut: true,
      paymentMethod: 'cash',
      discountType: 'SAR.',
      discountValue: 20,
      insuranceProvider: 15
    },
    {
      id: 4,
      date: '2024-06-30',
      timestamp: '2024-06-30 09:00 AM',
      items: [
        { id: 1, name: 'Blood Pressure Check', quantity: 1, pricePerItem: 50 },
        { id: 2, name: 'ECG', quantity: 1, pricePerItem: 300 }
      ],
      note: 'Emergency visit',
      isCheckedOut: true,
      paymentMethod: 'cash',
      discountType: 'SAR.',
      discountValue: 20,
      insuranceProvider: 15
    },
    {
      id: 5,
      date: '2024-06-30',
      timestamp: '2024-06-30 09:00 AM',
      items: [
        { id: 1, name: 'Blood Pressure Check', quantity: 1, pricePerItem: 50 },
        { id: 2, name: 'ECG', quantity: 1, pricePerItem: 300 }
      ],
      note: 'Emergency visit',
      isCheckedOut: true,
      paymentMethod: 'cash',
      discountType: 'SAR.',
      discountValue: 20,
      insuranceProvider: 15
    },
    {
      id: 6,
      date: '2024-06-30',
      timestamp: '2024-06-30 09:00 AM',
      items: [
        { id: 1, name: 'Blood Pressure Check', quantity: 1, pricePerItem: 50 },
        { id: 2, name: 'ECG', quantity: 1, pricePerItem: 300 }
      ],
      note: 'Emergency visit',
      isCheckedOut: true,
      paymentMethod: 'cash',
      discountType: 'SAR.',
      discountValue: 20,
      insuranceProvider: 15
    },
    {
      id: 7,
      date: '2024-06-30',
      timestamp: '2024-06-30 09:00 AM',
      items: [
        { id: 1, name: 'Blood Pressure Check', quantity: 1, pricePerItem: 50 },
        { id: 2, name: 'ECG', quantity: 1, pricePerItem: 300 }
      ],
      note: 'Emergency visit',
      isCheckedOut: true,
      paymentMethod: 'cash',
      discountType: 'SAR.',
      discountValue: 20,
      insuranceProvider: 15
    },
    {
      id: 8,
      date: '2024-06-30',
      timestamp: '2024-06-30 09:00 AM',
      items: [
        { id: 1, name: 'Blood Pressure Check', quantity: 1, pricePerItem: 50 },
        { id: 2, name: 'ECG', quantity: 1, pricePerItem: 300 }
      ],
      note: 'Emergency visit',
      isCheckedOut: true,
      paymentMethod: 'cash',
      discountType: 'SAR.',
      discountValue: 20,
      insuranceProvider: 15
    }
  ])

  const [selectedBill, setSelectedBill] = useState(bills[0])
  const [currentBill, setCurrentBill] = useState({
    id: null,
    date: new Date().toISOString().split('T')[0],
    timestamp: '',
    items: [{ id: 1, name: '', quantity: 1, pricePerItem: 0 }],
    note: '',
    isCheckedOut: false,
    paymentMethod: 'cash',
    discountType: 'SAR.',
    discountValue: 0,
    insuranceProvider: 5
  })

  // Calculate totals
  const calculateBillTotals = bill => {
    const subtotal = bill.items.reduce(
      (sum, item) => sum + item.quantity * item.pricePerItem,
      0
    )
    let discount = 0

    if (bill.discountType === 'SAR.') {
      discount = bill.discountValue
    } else {
      discount = (subtotal * bill.discountValue) / 100
    }

    const afterDiscount = subtotal - discount
    const insuranceAmount = (afterDiscount * bill.insuranceProvider) / 100
    const finalAmount = afterDiscount - insuranceAmount

    return {
      subtotal,
      discount,
      afterDiscount,
      insuranceAmount,
      finalAmount
    }
  }

  // Calculate balance and insured amount for badges
  const getTotalBalance = () => {
    return bills.reduce((total, bill) => {
      if (bill.isCheckedOut) {
        const totals = calculateBillTotals(bill)
        return total + totals.finalAmount
      }
      return total
    }, 0)
  }

  const getTotalInsured = () => {
    return bills.reduce((total, bill) => {
      if (bill.isCheckedOut) {
        const totals = calculateBillTotals(bill)
        return total + totals.insuranceAmount
      }
      return total
    }, 0)
  }

  const handleNewBill = () => {
    if (!hasPermission('billing', 'create')) return;
    const newBill = {
      id: Date.now(),
      date: new Date().toISOString().split('T')[0],
      timestamp: new Date().toLocaleString(),
      items: [{ id: 1, name: '', quantity: 1, pricePerItem: 0 }],
      note: '',
      isCheckedOut: false,
      paymentMethod: 'cash',
      discountType: 'SAR.',
      discountValue: 0,
      insuranceProvider: 5
    }
    setCurrentBill(newBill)
    setSelectedBill(newBill)
  }

  const handleDeleteBill = billId => {
    if (!hasPermission('billing', 'delete')) return;
    if (window.confirm('Are you sure you want to delete this bill?')) {
      setBills(bills.filter(bill => bill.id !== billId))
      if (selectedBill?.id === billId) {
        setSelectedBill(bills[0] || null)
      }
      toast.success('Bill deleted successfully')
    }
  }

  const handleAddItem = () => {
    if (!hasPermission('billing', 'update')) return;
    const newItem = {
      id: Date.now(),
      name: '',
      quantity: 1,
      pricePerItem: 0
    }

    if (selectedBill?.isCheckedOut) return

    if (selectedBill?.id === currentBill.id || !selectedBill?.id) {
      setCurrentBill(prev => ({
        ...prev,
        items: [...prev.items, newItem]
      }))
    }
  }

  const handleRemoveItem = itemId => {
    if (!hasPermission('billing', 'delete')) return;
    if (selectedBill?.isCheckedOut) return

    if (selectedBill?.id === currentBill.id || !selectedBill?.id) {
      setCurrentBill(prev => ({
        ...prev,
        items: prev.items.filter(item => item.id !== itemId)
      }))
    }
  }

  const handleItemChange = (itemId, field, value) => {
    if (selectedBill?.isCheckedOut) return

    if (selectedBill?.id === currentBill.id || !selectedBill?.id) {
      setCurrentBill(prev => ({
        ...prev,
        items: prev.items.map(item =>
          item.id === itemId ? { ...item, [field]: value } : item
        )
      }))
    }
  }

  const handleBillFieldChange = (field, value) => {
    if (selectedBill?.isCheckedOut) return

    if (selectedBill?.id === currentBill.id || !selectedBill?.id) {
      setCurrentBill(prev => ({ ...prev, [field]: value }))
    }
  }

  const handleCheckout = () => {
    if (!currentBill.items.some(item => item.name && item.pricePerItem > 0)) {
      toast.error('Please add at least one valid item before checkout')
      return
    }

    const checkedOutBill = {
      ...currentBill,
      isCheckedOut: true,
      timestamp: new Date().toLocaleString()
    }

    if (currentBill.id && bills.find(bill => bill.id === currentBill.id)) {
      setBills(
        bills.map(bill => (bill.id === currentBill.id ? checkedOutBill : bill))
      )
    } else {
      setBills([...bills, checkedOutBill])
    }

    setSelectedBill(checkedOutBill)
    toast.success('Bill checked out successfully')
  }

  const handleClear = () => {
    if (selectedBill?.isCheckedOut) return

    setCurrentBill({
      id: currentBill.id,
      date: new Date().toISOString().split('T')[0],
      timestamp: '',
      items: [{ id: 1, name: '', quantity: 1, pricePerItem: 0 }],
      note: '',
      isCheckedOut: false,
      paymentMethod: 'cash',
      discountType: 'SAR.',
      discountValue: 0,
      insuranceProvider: 5
    })
    toast.success('Bill cleared')
  }

  const handlePrint = () => {
    if (!selectedBill?.isCheckedOut) return

    const totals = calculateBillTotals(selectedBill)

    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Medical Bill - ${selectedBill.id}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; border-bottom: 2px solid #333; padding-bottom: 20px; margin-bottom: 20px; }
            .patient-info, .bill-info { margin: 20px 0; }
            .items-table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            .items-table th, .items-table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            .items-table th { background-color: #f2f2f2; }
            .totals { margin-top: 20px; text-align: right; }
            .totals div { margin: 5px 0; }
            .final-amount { font-weight: bold; font-size: 18px; border-top: 2px solid #333; padding-top: 10px; }
            .footer { margin-top: 40px; text-align: center; font-size: 12px; color: #666; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>SUPERGIT HOSPITAL</h1>
            <h2>Medical Bill</h2>
            <p>Bill ID: ${selectedBill.id} | Date: ${selectedBill.date}</p>
          </div>
          
          <div class="patient-info">
            <h3>Patient Information</h3>
            <p><strong>Name:</strong> ${patient?.name || 'N/A'}</p>
            <p><strong>ID:</strong> ${patient?.id || 'N/A'}</p>
            <p><strong>Phone:</strong> ${patient?.phone || 'N/A'}</p>
          </div>
          
          <div class="bill-info">
            <h3>Bill Details</h3>
            <p><strong>Date:</strong> ${selectedBill.date}</p>
            <p><strong>Time:</strong> ${selectedBill.timestamp}</p>
            <p><strong>Payment Method:</strong> ${
              selectedBill.paymentMethod
            }</p>
            ${
              selectedBill.note
                ? `<p><strong>Note:</strong> ${selectedBill.note}</p>`
                : ''
            }
          </div>
          
          <table class="items-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Quantity</th>
                <th>Price per Item</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              ${selectedBill.items
                .map(
                  item => `
                <tr>
                  <td>${item.name}</td>
                  <td>${item.quantity}</td>
                  <td>SAR. ${item.pricePerItem}</td>
                  <td>SAR. ${item.quantity * item.pricePerItem}</td>
                </tr>
              `
                )
                .join('')}
            </tbody>
          </table>
          
          <div class="totals">
            <div>Subtotal: SAR. ${totals.subtotal}</div>
            <div>Discount (${
              selectedBill.discountType === 'SAR.'
                ? 'SAR.'
                : selectedBill.discountValue + '%'
            }): SAR. ${totals.discount}</div>
            <div>After Discount: SAR. ${totals.afterDiscount}</div>
            <div>Insurance (${selectedBill.insuranceProvider}%): SAR. ${
      totals.insuranceAmount
    }</div>
            <div class="final-amount">Final Amount: SAR. ${
              totals.finalAmount
            }</div>
          </div>
          
          <div class="footer">
            <p>Thank you for choosing Supergit Hospital</p>
            <p>This is a computer generated bill</p>
          </div>
        </body>
      </html>
    `

    const printWindow = window.open('', '_blank')
    printWindow.document.write(printContent)
    printWindow.document.close()
    printWindow.print()
  }

  const currentBillTotals = calculateBillTotals(
    selectedBill?.id === currentBill.id
      ? currentBill
      : selectedBill || currentBill
  )

  return (
    <div className='h-full flex flex-col'>
      {/* Header */}
      <div className='p-6 pb-4 flex-shrink-0'>
        <div className='flex items-center justify-between mb-6'>
          <h2 className='text-2xl font-bold'>Patient Bills</h2>

          {/* Badges and Buttons */}
          <div className='flex items-center space-x-4'>
            {/* Balance Badge */}
            <div className='bg-blue-100 text-blue-800 px-4 py-2 rounded-lg'>
              <div className='flex items-center space-x-2'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth={1.5}
                  stroke='currentColor'
                  className='w-6 h-6'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V9'
                  />
                </svg>
                <div>
                  <div className='text-xs font-medium'>Total Balance</div>
                  <div className='text-lg font-bold'>
                    SAR. {getTotalBalance().toFixed(2)}
                  </div>
                </div>
              </div>
            </div>

            {/* Insured Amount Badge */}
            <div className='bg-green-100 text-green-800 px-4 py-2 rounded-lg'>
              <div className='flex items-center space-x-2'>
                <FaShieldAlt size={16} />
                <div>
                  <div className='text-xs font-medium'>Insured Amount</div>
                  <div className='text-lg font-bold'>
                    SAR. {getTotalInsured().toFixed(2)}
                  </div>
                </div>
              </div>
            </div>

            {/* Email Balance Button */}
            <CustomButton
              onClick={() => toast.error('Email feature coming soon')}
              label='Email Balance'
              icon={<FaEnvelope size={14} />}
              buttonType='blue'
              className='!h-[40px]'
            />

            {/* New Bill Button */}
            <CustomButton
              onClick={handleNewBill}
              label='New Bill'
              icon={<FaPlus size={14} />}
              buttonType='primary'
              className='!h-[40px]'
            />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className='flex-1 px-6 pb-6 overflow-y-auto'>
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 h-[calc(100vh-200px)]'>
          {/* Left Side - Bills List */}
          <div className='lg:col-span-1 bg-gray-50 rounded-lg flex flex-col overflow-y-auto max-h-[calc(100vh-250px)]'>
            <div className='p-4 pb-3 flex-shrink-0 border-b border-gray-200'>
              <h3 className='text-lg font-semibold text-gray-800'>
                Bills History
              </h3>
              <div className='text-sm text-gray-600 mt-1'>
                {bills.length} bill(s)
              </div>
            </div>

            {/* Bills List */}
            <div className='flex-1 overflow-y-auto p-4'>
              <div className='space-y-2'>
                {bills.map(bill => (
                  <div
                    key={bill.id}
                    onClick={() => {
                      setSelectedBill(bill)
                      if (!bill.isCheckedOut) {
                        setCurrentBill(bill)
                      }
                    }}
                    className={`p-3 rounded-lg cursor-pointer border transition-colors ${
                      selectedBill?.id === bill.id
                        ? 'bg-blue-50 border-blue-200'
                        : 'bg-white border-gray-200 hover:bg-gray-50'
                    }`}
                  >
                    <div className='flex items-start justify-between'>
                      <div className='flex-1'>
                        <div className='font-medium text-gray-800'>
                          Bill #{bill.id}
                        </div>
                        <div className='text-sm text-gray-500'>
                          {bill.timestamp}
                        </div>
                        <div className='text-xs mt-1'>
                          {bill.isCheckedOut ? (
                            <span className='bg-green-100 text-green-800 px-2 py-1 rounded'>
                              Checked Out
                            </span>
                          ) : (
                            <span className='bg-yellow-100 text-yellow-800 px-2 py-1 rounded'>
                              Draft
                            </span>
                          )}
                        </div>
                      </div>

                      <button
                        onClick={e => {
                          e.stopPropagation()
                          handleDeleteBill(bill.id)
                        }}
                        className='p-1 text-gray-400 hover:text-red-500'
                        title='Delete Bill'
                      >
                        <FaTrash size={12} />
                      </button>
                    </div>
                  </div>
                ))}

                {bills.length === 0 && (
                  <div className='text-center text-gray-500 py-8'>
                    <FaNotesMedical
                      size={48}
                      className='mx-auto mb-4 text-gray-300'
                    />
                    <p>No bills found</p>
                    <p className='text-sm mt-1'>
                      Create a new bill to get started
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Side - Bill Details/Order Summary */}
          <div className='lg:col-span-2 bg-white rounded-lg flex flex-col border border-gray-200 overflow-y-auto max-h-[calc(100vh-250px)]'>
            <div className='p-4 pb-3 flex-shrink-0 border-b border-gray-200'>
              <div className='flex items-center justify-between'>
                <h3 className='text-lg font-semibold text-gray-800'>
                  {selectedBill
                    ? selectedBill.isCheckedOut
                      ? 'Bill Summary'
                      : 'Order Summary'
                    : 'Select a Bill'}
                </h3>
                {selectedBill?.isCheckedOut && (
                  <CustomButton
                    onClick={handlePrint}
                    label='Print'
                    icon={<FaPrint size={14} />}
                    buttonType='primary'
                    className='!h-[35px]'
                  />
                )}
              </div>
            </div>

            <div className='flex-1 overflow-y-auto p-4'>
              {selectedBill ? (
                <div className='space-y-6'>
                  {/* Date Selector */}
                  {!selectedBill.isCheckedOut && (
                    <div className='flex items-center space-x-2'>
                      <FaCalendarAlt className='text-gray-500' />
                      <label className='text-sm font-medium text-gray-700'>
                        Date:
                      </label>
                      <input
                        type='date'
                        value={
                          selectedBill.id === currentBill.id
                            ? currentBill.date
                            : selectedBill.date
                        }
                        onChange={e =>
                          handleBillFieldChange('date', e.target.value)
                        }
                        className='border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                        disabled={selectedBill.isCheckedOut}
                      />
                    </div>
                  )}

                  {/* Items Table */}
                  <div className='bg-gray-50 rounded-lg p-4'>
                    <h4 className='text-md font-semibold mb-4'>Items</h4>
                    <div className='overflow-x-auto'>
                      <table className='w-full'>
                        <thead>
                          <tr className='border-b border-gray-200'>
                            <th className='text-left py-2 px-3'>Item Name</th>
                            <th className='text-left py-2 px-3'>Quantity</th>
                            <th className='text-left py-2 px-3'>
                              Price per Item
                            </th>
                            <th className='text-left py-2 px-3'>Total</th>
                            {!selectedBill.isCheckedOut && (
                              <th className='text-left py-2 px-3'>Action</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {(selectedBill.id === currentBill.id
                            ? currentBill.items
                            : selectedBill.items
                          ).map(item => (
                            <tr
                              key={item.id}
                              className='border-b border-gray-100'
                            >
                              <td className='py-2 px-3'>
                                {selectedBill.isCheckedOut ? (
                                  <span>{item.name}</span>
                                ) : (
                                  <input
                                    type='text'
                                    value={item.name}
                                    onChange={e =>
                                      handleItemChange(
                                        item.id,
                                        'name',
                                        e.target.value
                                      )
                                    }
                                    className='w-full border border-gray-300 rounded px-2 py-1 text-sm'
                                    placeholder='Item name'
                                  />
                                )}
                              </td>
                              <td className='py-2 px-3'>
                                {selectedBill.isCheckedOut ? (
                                  <span>{item.quantity}</span>
                                ) : (
                                  <input
                                    type='number'
                                    value={item.quantity}
                                    onChange={e =>
                                      handleItemChange(
                                        item.id,
                                        'quantity',
                                        parseInt(e.target.value) || 1
                                      )
                                    }
                                    className='w-full border border-gray-300 rounded px-2 py-1 text-sm'
                                    min='1'
                                  />
                                )}
                              </td>
                              <td className='py-2 px-3'>
                                {selectedBill.isCheckedOut ? (
                                  <span>SAR. {item.pricePerItem}</span>
                                ) : (
                                  <input
                                    type='number'
                                    value={item.pricePerItem}
                                    onChange={e =>
                                      handleItemChange(
                                        item.id,
                                        'pricePerItem',
                                        parseFloat(e.target.value) || 0
                                      )
                                    }
                                    className='w-full border border-gray-300 rounded px-2 py-1 text-sm'
                                    min='0'
                                    step='0.01'
                                  />
                                )}
                              </td>
                              <td className='py-2 px-3'>
                                SAR.{' '}
                                {(item.quantity * item.pricePerItem).toFixed(2)}
                              </td>
                              {!selectedBill.isCheckedOut && (
                                <td className='py-2 px-3'>
                                  <button
                                    onClick={() => handleRemoveItem(item.id)}
                                    className='text-red-500 hover:text-red-700'
                                    title='Remove item'
                                  >
                                    <FaTrash size={12} />
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {!selectedBill.isCheckedOut && (
                      <button
                        onClick={handleAddItem}
                        className='mt-3 text-blue-600 hover:text-blue-800 text-sm flex items-center space-x-1'
                      >
                        <FaPlus size={12} />
                        <span>Add Item</span>
                      </button>
                    )}
                  </div>

                  {/* Note */}
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-2'>
                      Note
                    </label>
                    {selectedBill.isCheckedOut ? (
                      <div className='p-3 bg-gray-50 border border-gray-200 rounded-md'>
                        {selectedBill.note || 'No note added'}
                      </div>
                    ) : (
                      <textarea
                        value={
                          selectedBill.id === currentBill.id
                            ? currentBill.note
                            : selectedBill.note
                        }
                        onChange={e =>
                          handleBillFieldChange('note', e.target.value)
                        }
                        className='w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                        rows='3'
                        placeholder='Add a note...'
                      />
                    )}
                  </div>

                  {/* Payment Details (Only shown after checkout) */}
                  {selectedBill.isCheckedOut && (
                    <div className='bg-blue-50 rounded-lg p-4'>
                      <h4 className='text-md font-semibold mb-4'>
                        Payment Details
                      </h4>
                      <div className='grid grid-cols-2 gap-4'>
                        <div>
                          <label className='block text-sm font-medium text-gray-700 mb-1'>
                            Payment Method
                          </label>
                          <div className='p-2 bg-white border border-gray-200 rounded-md'>
                            {selectedBill.paymentMethod}
                          </div>
                        </div>
                        <div>
                          <label className='block text-sm font-medium text-gray-700 mb-1'>
                            Discount
                          </label>
                          <div className='p-2 bg-white border border-gray-200 rounded-md'>
                            {selectedBill.discountValue}{' '}
                            {selectedBill.discountType}
                          </div>
                        </div>
                      </div>

                      <div className='mt-4 space-y-2'>
                        <div className='flex justify-between'>
                          <span>Subtotal:</span>
                          <span>
                            SAR. {currentBillTotals.subtotal.toFixed(2)}
                          </span>
                        </div>
                        <div className='flex justify-between'>
                          <span>Discount:</span>
                          <span>
                            SAR. {currentBillTotals.discount.toFixed(2)}
                          </span>
                        </div>
                        <div className='flex justify-between'>
                          <span>After Discount:</span>
                          <span>
                            SAR. {currentBillTotals.afterDiscount.toFixed(2)}
                          </span>
                        </div>
                        <div className='flex justify-between'>
                          <span>
                            Insurance ({selectedBill.insuranceProvider}%):
                          </span>
                          <span>
                            SAR. {currentBillTotals.insuranceAmount.toFixed(2)}
                          </span>
                        </div>
                        <div className='flex justify-between font-bold text-lg border-t pt-2'>
                          <span>Final Amount:</span>
                          <span>
                            SAR. {currentBillTotals.finalAmount.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Payment Form (Only shown before checkout) */}
                  {!selectedBill.isCheckedOut && (
                    <div className='bg-gray-50 rounded-lg p-4'>
                      <h4 className='text-md font-semibold mb-4'>
                        Payment Information
                      </h4>
                      <div className='grid grid-cols-2 gap-4 mb-4'>
                        <div>
                          <label className='block text-sm font-medium text-gray-700 mb-1'>
                            Payment Method
                          </label>
                          <select
                            value={
                              selectedBill.id === currentBill.id
                                ? currentBill.paymentMethod
                                : selectedBill.paymentMethod
                            }
                            onChange={e =>
                              handleBillFieldChange(
                                'paymentMethod',
                                e.target.value
                              )
                            }
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                          >
                            <option value='cash'>Cash</option>
                            <option value='card'>Card</option>
                            <option value='online'>Online</option>
                            <option value='bank transfer'>Bank Transfer</option>
                            <option value='mobile money'>Mobile Money</option>
                            <option value='paypal'>PayPal</option>
                            <option value='paystack'>Paystack</option>
                          </select>
                        </div>
                        <div>
                          <label className='block text-sm font-medium text-gray-700 mb-1'>
                            Discount Type
                          </label>
                          <select
                            value={
                              selectedBill.id === currentBill.id
                                ? currentBill.discountType
                                : selectedBill.discountType
                            }
                            onChange={e =>
                              handleBillFieldChange(
                                'discountType',
                                e.target.value
                              )
                            }
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                          >
                            <option value='SAR.'>SAR.</option>
                            <option value='%'>%</option>
                          </select>
                        </div>
                        <div>
                          <label className='block text-sm font-medium text-gray-700 mb-1'>
                            Discount Value
                          </label>
                          <input
                            type='number'
                            value={
                              selectedBill.id === currentBill.id
                                ? currentBill.discountValue
                                : selectedBill.discountValue
                            }
                            onChange={e =>
                              handleBillFieldChange(
                                'discountValue',
                                parseFloat(e.target.value) || 0
                              )
                            }
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                            min='0'
                            step='0.01'
                          />
                        </div>
                        <div>
                          <label className='block text-sm font-medium text-gray-700 mb-1'>
                            Insurance Provider (%)
                          </label>
                          <input
                            type='number'
                            value={
                              selectedBill.id === currentBill.id
                                ? currentBill.insuranceProvider
                                : selectedBill.insuranceProvider
                            }
                            onChange={e =>
                              handleBillFieldChange(
                                'insuranceProvider',
                                parseFloat(e.target.value) || 0
                              )
                            }
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                            min='0'
                            max='100'
                            step='0.1'
                          />
                        </div>
                      </div>

                      {/* Bill Totals */}
                      <div className='border-t pt-4'>
                        <div className='space-y-2'>
                          <div className='flex justify-between'>
                            <span>Subtotal:</span>
                            <span>
                              SAR. {currentBillTotals.subtotal.toFixed(2)}
                            </span>
                          </div>
                          <div className='flex justify-between'>
                            <span>Discount:</span>
                            <span>
                              SAR. {currentBillTotals.discount.toFixed(2)}
                            </span>
                          </div>
                          <div className='flex justify-between'>
                            <span>After Discount:</span>
                            <span>
                              SAR. {currentBillTotals.afterDiscount.toFixed(2)}
                            </span>
                          </div>
                          <div className='flex justify-between'>
                            <span>
                              Insurance (
                              {selectedBill.id === currentBill.id
                                ? currentBill.insuranceProvider
                                : selectedBill.insuranceProvider}
                              %):
                            </span>
                            <span>
                              SAR.{' '}
                              {currentBillTotals.insuranceAmount.toFixed(2)}
                            </span>
                          </div>
                          <div className='flex justify-between font-bold text-lg border-t pt-2'>
                            <span>Final Amount:</span>
                            <span>
                              SAR. {currentBillTotals.finalAmount.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className='flex items-center justify-end space-x-3 pt-4 border-t'>
                    {!selectedBill.isCheckedOut && (
                      <>
                        <CustomButton
                          onClick={handleClear}
                          label='Clear'
                          icon={<FaBroom size={14} />}
                          buttonType='reset'
                          className='!h-[40px]'
                        />
                        <CustomButton
                          onClick={handleCheckout}
                          label='Checkout'
                          icon={<FaCheck size={14} />}
                          buttonType='primary'
                          className='!h-[40px]'
                        />
                      </>
                    )}

                    {selectedBill.isCheckedOut && (
                      <CustomButton
                        onClick={handlePrint}
                        label='Print Bill'
                        icon={<FaPrint size={14} />}
                        buttonType='primary'
                        className='!h-[40px]'
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className='flex items-center justify-center h-full text-gray-500'>
                  <div className='text-center'>
                    <FaNotesMedical
                      size={64}
                      className='mx-auto mb-4 text-gray-300'
                    />
                    <p className='text-lg mb-2'>No bill selected</p>
                    <p>
                      Choose a bill from the list to view details or create a
                      new bill
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BillsTab
